import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

function Navigation({ setPage }) {
    return (
        <Navbar expand="lg" className="navbar-dark bg-transparent site-nav">
            <Container>
                <Navbar.Brand href="#" onClick={() => setPage('home')} className="d-flex align-items-center gap-2">
                    <img
                        src="/qcoda_icon_white.png"
                        alt="Qcoda Logo"
                        height="36"
                        className="d-inline-block align-top rounded"
                    />
                    <span className="fw-bold text-white fs-4">QCoda &mdash; The Alignment Layer for AI-Built Software</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="#" onClick={() => setPage('home')} className="text-white fw-medium">Home</Nav.Link>
                        <Nav.Link href="#" onClick={() => setPage('contact')} className="text-white fw-medium">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
